import React, { useContext, useState } from 'react';
import { addNewUserInfo, createUserUpdate, omitUndefined, UserContext } from '../services/firebase';
import LayoutOnboarding from '../components/LayoutOnboarding';
import { User } from '../shared/types';
import { FormInput } from '@/components/forms/FormInput';
import { FormSelect } from '@/components/forms/FormSelect';
import { Button } from '@/components/ui/button';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from '@/components/ui/card';
import { FieldGroup } from '@/components/ui/field';
import { SelectItem } from '@/components/ui/select';
// import { useNavigate } from "react-router-dom";

const NewUserInfo: React.FC<any> = () => {
    const user = useContext(UserContext);
    const [campaignType, setCampaignType] = useState<string>(user?.campaignType || '');
    // const navigate = useNavigate();

    async function submitForm(e: any, user: any) {
        e.preventDefault();

        const form = e.currentTarget;
        const firstName = (form.elements.namedItem('firstName') as HTMLInputElement).value;
        const lastName = (form.elements.namedItem('lastName') as HTMLInputElement).value;
        const company = (form.elements.namedItem('company') as HTMLInputElement).value;

        if (campaignType) {
            const isGrailEmail = user?.email?.toLowerCase().includes('grail-talent.com');
            const isGrailDomain = user?.orgDomain?.toLowerCase().includes('grail-talent.com');

            await addNewUserInfo(user.id, createUserUpdate(omitUndefined({
                firstName,
                lastName,
                company,
                campaignType: campaignType as NonNullable<User['campaignType']>,
                roles: !isGrailEmail && !isGrailDomain ? { booker: true } : undefined,
            })));
            // navigate('/');
        }
    }

    return (
        <div>
            <LayoutOnboarding>
                <form className="mx-auto w-80 max-w-full" onSubmit={(e) => submitForm(e, user)}>
                    <Card>
                        <CardHeader>
                            <CardTitle>Almost Done!</CardTitle>
                            <CardDescription>Just one more step!</CardDescription>
                        </CardHeader>
                        <CardContent>
                            <FieldGroup className="gap-4">
                                <FormInput label="First Name" name="firstName" placeholder="First Name" required defaultValue={user?.firstName || ''} />
                                <FormInput label="Last Name" name="lastName" placeholder="Last Name" required defaultValue={user?.lastName || ''} />
                                <FormInput label="Company" name="company" placeholder="Company" required defaultValue={user?.company || ''} />
                                <FormSelect
                                    label="Your Promo Type"
                                    required
                                    description="What type of promotions do you primarily run?"
                                    value={campaignType || null}
                                    onChange={(value) => setCampaignType(value ?? '')}
                                    placeholder="Choose Type..."
                                >
                                    <SelectItem value="Song">Song Promos</SelectItem>
                                    <SelectItem value="Brand">Brand Promos</SelectItem>
                                    <SelectItem value="Multi">Both (I work at an Agency)</SelectItem>
                                </FormSelect>

                                <Button type="submit" className="w-full">
                                    Let's Do This!
                                </Button>
                            </FieldGroup>
                        </CardContent>
                    </Card>
                </form>
                {/* {user?.campaignType ? <Redirect to="/" /> : null} */}
            </LayoutOnboarding>
        </div>
    );
};

export default NewUserInfo;
